import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { promptCookieConsent, syncCookieConsent } from '@/services/cookies'
import {
  identifyUserInTracking,
  startTracking,
  stopTracking,
} from '@/services/tracking'
import { getStateData } from '@/store/getters'


export default /*#__PURE__*/_defineComponent({
  __name: 'CookieLink',
  setup(__props) {

const openCookiesModal = async () => {
  const profile = !!getStateData().profile
  const consent = await promptCookieConsent()
  if (consent.ANALYTICS) {
    startTracking()
    if (profile) {
      await identifyUserInTracking()
      await syncCookieConsent()
    }
  } else {
    stopTracking()
    if (profile) {
      await syncCookieConsent()
    }
    // Reload the page, because there is no way to stop/undo monitor scripts
    window.location.reload()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dsf-link", {
    dsf_size: "medium",
    onClick: openCookiesModal
  }, _toDisplayString(_ctx.$t('general.cookiePreferences')), 1 /* TEXT */))
}
}

})